import * as React from 'react';
import { ContentService } from '../../services'

export default class extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            content: null,
            loading: false
        }
    }

    componentDidMount() {
        if (this.props._key) {
            ContentService.getContent(this.props._key)
                .then(value => {
                    this.props.loaded ? this.props.loaded() : null;
                    this.setState({
                        content: value.content,
                        loading: true
                    })
                })
        }

    }

    render() {
        return (this.props._key) ? (
            this.state.loading && this.state.content ? (

                <div dangerouslySetInnerHTML={{ __html: this.state.content }}></div>
            ) : null) : <div dangerouslySetInnerHTML={{ __html: this.props.content }}></div>
    }
}